<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Tipo de movimiento de nómina</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            id="codigo"
            v-model="form.codigo"
            placeholder="Escriba el código..."
          >
            Código
            <span
              v-if="errores.codigo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.codigo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            id="descripcion"
            v-model="form.descripcion"
            placeholder="Escriba la descripción..."
          >
            Descripción
            <span
              v-if="errores.descripcion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.descripcion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select">
          <div class="select-field">
            <select name="tipo" v-model="form.tipo" id="tipo">
              <option value="I">Ingreso</option>
              <option value="G">Descuento</option>
            </select>
            <label for="tipo">Tipo</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select">
          <div class="select-field">
            <select name="tipo_aplicacion" v-model="form.tipo_aplicacion" id="tipo">
              <option value="V">Vendedor</option>
              <option value="S">Supervisor</option>
              <option value="R">Recaudador</option>
            </select>
            <label for="tipo_aplicacion">Tipo de aplicación</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          codigo: "",
          descripcion: "",
          tipo: 'G'
        };
      },
    },
  },
  data: function () {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
      errores: {},
    };
  },
  methods: {
    guardar: function () {
      swal({
        title: "¿Desea almacenar el tipo de movimiento?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/tipos-movimiento-nomina";
          axios
            .post(urlRequest, this.form)
            .then(() => {
              swal(
                "El tipo de movimiento fue almacenado exitósamente.",
                "Realizado",
                "success"
              );
              this.$emit("saved");
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    cancelar: function () {
      this.$emit("cancelar");
    },
  },
  mounted: function () {
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/TipoMovimiento.vue